import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { DbServiceService } from 'src/app/services/db-service.service';
import { SurveyFull } from 'src/app/common/survey-full';
import { UntypedFormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { QuestionBase } from 'src/app/common/question-base';
import { QuestionControlService } from 'src/app/services/question-control.service';
import { AuthService } from 'src/app/services/auth.service';


@Component({
  selector: 'app-take-survey',
  templateUrl: './take-survey.component.html',
  styleUrls: ['./take-survey.component.css']
})
export class TakeSurveyComponent implements OnInit {

  surveyId: number;

  constructor(private route: ActivatedRoute, private dbService: DbServiceService,
    private fb: UntypedFormBuilder, private qcs: QuestionControlService, private auth: AuthService) {
  }

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.has('id')) {
      this.surveyId = +this.route.snapshot.paramMap.get('id');
    } else {
      this.surveyId = 1;
    }
  }
}
